<div style="width: 100vw; height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center;">
    <div style="display: flex; align-items: center; gap: 16px;">
        <mat-spinner [diameter]="fontSize"></mat-spinner>
        <p style="margin: 0;" [style.font-size.px]="fontSize">Loading Profile<span *ngIf="showEllipsis">&hellip;</span></p>
    </div>
</div>
